export const FEATURE_OVERRIDE_ENABLED = 'featureOverrideEnabled';
export const FEATURE_AB_TESTING = 'ab';
export const FEATURE_DEALER_SEARCH_CHINA = 'dealer_search_china';
export const FEATURE_SENTRY = 'sentry';
export const FEATURE_NAVI_DRAWER_FROM_CDN = 'navi_drawer_cdn';
